import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useData } from '../context/DataContext';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const RotacionInventarioBar = () => {
  const [infoOpen, setInfoOpen] = useState(false);
  const { getInventoryRotation, dataReady } = useData();

  // Get data from Excel (3 years) - NOT percentage
  const excelData = dataReady ? getInventoryRotation() : { labels: [], data2022: [], data2023: [], data2024: [] };

  // Use Excel data or fallback
  const labels = excelData.labels.length > 0
    ? excelData.labels
    : ['Construcción', 'Alimentos', 'Retail', 'Servicios Logísticos', 'Sector salud/ Farmacéuticas', 'Automotriz', 'Manufactura'];

  const data2022 = excelData.data2022.length > 0 ? excelData.data2022 : [6.4, 6.1, 5.2, 4.0, 8.0, 6.0, 6.8];
  const data2023 = excelData.data2023.length > 0 ? excelData.data2023 : [12.3, 8.5, 10.5, 4.4, 0, 2.7, 2.7];
  const data2024 = excelData.data2024.length > 0 ? excelData.data2024 : [8.7, 11.3, 8.1, 9.5, 4.6, 3.4, 4.5];

  const chartData = {
    labels,
    datasets: [
      {
        label: '2023',
        data: data2022,
        backgroundColor: '#A2AEBB',
        borderColor: '#fff',
        borderWidth: 1,
        barThickness: 12,
      },
      {
        label: '2024',
        data: data2023,
        backgroundColor: '#476A8E',
        borderColor: '#fff',
        borderWidth: 1,
        barThickness: 12,
      },
      {
        label: '2025',
        data: data2024,
        backgroundColor: '#1F3D58',
        borderColor: '#fff',
        borderWidth: 1,
        barThickness: 12,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 40,
        bottom: 40,
        left: 10,
        right: 10,
      },
    },
    indexAxis: 'y',
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}`,
        },
      },
      datalabels: {
        color: '#000',
        font: {
          weight: 'bold',
          size: 9,
        },
        formatter: (value) => (value !== null && value > 0 ? `${value}` : ''),
        anchor: 'end',
        align: 'right',
        offset: 4,
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        max: 16,
        ticks: {
          stepSize: 2,
          font: {
            size: 12,
          },
        },
        title: {
          display: true,
          text: 'Rotación Anual',
          font: {
            size: 12,
          },
        },
      },
      y: {
        ticks: {
          font: {
            size: 12,
          },
        },
        title: {
          display: true,
          text: 'Industria',
          font: {
            size: 12,
          },
        },
      },
    },
  };

  const infoContent = {
    formula: 'Rotación de Inventario = Costo de los bienes vendidos / Promedio de inventario',
    description: 'Mide la cantidad de veces que el inventario promedio rota en un año de ventas.',
  };

  return (
    <div style={{ maxWidth: '800px', height: '500px', margin: '0 auto', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default RotacionInventarioBar;
